import React, { /*useContext,*/ useEffect, useState } from 'react';
import { Container, Box, Button, TextField , TableContainer, Table, TableHead,TableRow, TableCell, TableBody } from '@mui/material';
//import { useNavigate } from 'react-router-dom';
//import { AuthContext } from '../context/AuthContext';
import MenuAppBar from '../components/MenuAppBar';
import MenuBottAppBar from '../components/MenuBottAppBar';
import Paper from '@mui/material/Paper';
import Snackbar from '@mui/material/Snackbar';
import axios from "axios";

const EnergieDataObdEntity = () => {
  //const { logout, role } = useContext(AuthContext);
  //const navigate = useNavigate();

  const [roky, setRoky] = useState([]);
  const [obdobi, setObdobi] = useState([]);
  const [actrok, setActrok] = useState((new Date()).getFullYear().toString());
  const [actobdobi, setActobdobi] = useState((new Date()).getFullYear().toString()+'.'+('0' + ((new Date()).getMonth()+1)).slice(-2).toString());
  const [data, setData] = useState([]);
  //const [selectedRow, setSelectedRow] = useState(null);
  
  const [loading, setLoading] = useState(true);
  //const [error, setError] = useState(null);
  const [sneckmessage, setSneckmessage] = useState(null);
  const [opensneckmessage, setOpensneckmessage] = useState(false);
  
  const getAuthHeaders = () => {
    const token = localStorage.getItem("accessToken");
    return { Authorization: `Bearer ${token}` };
  };
  

  
  /*const loadData = async (rok, obdobi) => {


    const data0 = await axios.get("/api/energie/roky", { headers: getAuthHeaders(), params:{}});
    const roky = [];
    data0.data.forEach(element => {
      roky.push(element.rok);
    });
    setRoky(roky);

    const data1 = await axios.get("/api/energie/obdobi", { headers: getAuthHeaders(), params:{"rok":rok}});
    setObdobi(data1.data);

    const entData = await axios.get("/api/energie/entitydata", { headers: getAuthHeaders(), params:{"obdobi":obdobi}});
    setData(entData.data);

    setLoading(false);
    

    
    //setData([data1.data,data2.data]);
    
   


  };*/
  const saveRow = async (index) => {
    try {
      const rowData = data[index]; // Získání upraveného řádku
      //console.log("Ukládám řádek:", rowData);
  
      // Odeslání na server (upravit podle API)
      await axios.post("/api/energie/entityobddata", rowData, { headers: getAuthHeaders() });

      /*let sortedData = [...data].sort((a, b) => {
        (b.spotreba > a.spotreba) ? 1 : -1;
      });
      setData(sortedData);*/

      data.sort((a, b) => b.spotreba - a.spotreba);
      setData([...data]);

      setSneckmessage("Úspěšně uloženo!");
      setOpensneckmessage(true);
  
      //alert("Úspěšně uloženo!");
    } catch (error) {
      //console.error("Chyba při ukládání:", error);
      alert("Chyba při ukládání dat.");
    }
  };
  
  useEffect(() => {

    const fetchData = async (rok, obdobi) => {
      const data0 = await axios.get("/api/energie/roky", { headers: getAuthHeaders(), params:{}});
      const roky = [];
      data0.data.forEach(element => {
        roky.push(element.rok);
      });
      setRoky(roky);

      const data1 = await axios.get("/api/energie/obdobi", { headers: getAuthHeaders(), params:{"rok":rok}});
      setObdobi(data1.data);

      const entData = await axios.get("/api/energie/entityobddata", { headers: getAuthHeaders(), params:{"obdobi":obdobi}});
      setData(entData.data);

      setLoading(false);

    };

    fetchData(actrok, actobdobi);
    //loadData(actrok, actobdobi);

  }, [actrok, actobdobi]);

  const handleChange = (index, newValue) => {
    setData(prevData => 
      prevData.map((item, i) => 
        i === index ? { ...item, spotreba: parseFloat(newValue) } : item
      )
    );
  };

  const handleKeyPress = (index, ev) => {
    if (ev.key === 'Enter') {
      saveRow(index);
    }
  };

  const handleClosesneckmessage = () => {
    //setState({ ...state, open: false });
    setOpensneckmessage(false);
  };

  if (loading) return <p>Načítání...</p>;
  //if (error) return <p>Chyba: {error}</p>;
  

  return (
    
    <Container>
    <MenuAppBar title='Energie - Data entity' />
    
    <Box>
    {
      roky.map((rok, index) => (
        
        <Button variant={(rok==actrok) ? 'contained':'outlined'} color={(rok==actrok) ? 'success' : 'primary'} key={'rok-'+index} onClick={() => {
          setActrok(rok);
          var obd = actobdobi;
          if (!actobdobi.includes(rok)){
            obd = rok+'.01';
            setActobdobi(obd) ;
          }
          //loadData(rok, obd);
                      
        }}>{rok}</Button>
      ))
    }
    </Box>
    <Box>
    {
      obdobi.map((obdobi, index) => (
        
        <Button variant={(obdobi.obdobi==actobdobi) ? 'contained':'outlined'} color={(obdobi.obdobi==actobdobi) ? 'success' : 'primary'} key={'rok-'+index} onClick={() => {
          setActobdobi(obdobi.obdobi);
          //loadData(actrok, obdobi.obdobi);
                      
        }}>{obdobi.obdobi}</Button>
      ))
    }
    </Box>
    <Box>
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Entita</TableCell>
            <TableCell>Období</TableCell>
            <TableCell>Spotřeba</TableCell>
            
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow
              key={row.idenergieentitaspotrobd}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                <TextField
                  disabled
                  value={row.EnergieEntita.entita}
                />
              </TableCell>
              <TableCell component="th" scope="row">
                <TextField
                  disabled
                  value={row.Obdobi.obdobi}
                />
              </TableCell>
              <TableCell align="right">
                <TextField
                fullWidth
                variant="outlined"
                type="number"
                id={"fld-"+row.idenergieentitaspotrobd}
                value={row.spotreba}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyPress={(e) => handleKeyPress(index, e)}
                onClick={(e) => e.target.select()}
                />
              </TableCell>
              
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </Box>
    {sneckmessage && (
    <Snackbar
      open={opensneckmessage}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={1000}
      onClose={handleClosesneckmessage}
      message={sneckmessage}
    />
    )}
<MenuBottAppBar value={'Energie'} />
</Container>

       
  );
};

export default EnergieDataObdEntity;
